import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// Configurable at build time via REACT_APP_API_URL — defaults to localhost for dev.
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
export const WS_URL = process.env.REACT_APP_WS_URL ||
  API_BASE_URL.replace(/^http/, 'ws').replace(/\/api\/?$/, '/ws');

// Single axios instance used by everything
export const authApi = axios.create({ baseURL: API_BASE_URL });

// Attach token from localStorage on every request
authApi.interceptors.request.use(config => {
  const token = localStorage.getItem('salesai_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('salesai_token');
    const saved = localStorage.getItem('salesai_user');
    if (token && saved) {
      try { setUser(JSON.parse(saved)); }
      catch(e) {
        localStorage.removeItem('salesai_token');
        localStorage.removeItem('salesai_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const r = await authApi.post('/auth/login', { email, password });
    const { token, user: u } = r.data;
    localStorage.setItem('salesai_token', token);
    localStorage.setItem('salesai_user',  JSON.stringify(u));
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem('salesai_token');
    localStorage.removeItem('salesai_user');
    setUser(null);
  };

  const can = (permission) => {
    if (!user) return false;
    return (user.permissions || []).includes(permission);
  };

  const isAdmin = () => user?.role === 'admin';

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};
